
import html from '../images/html.png';
import css from '../images/css.png';
import js from '../images/js.png';
import react from '../images/react.png';
import sql from '../images/sql.png';
import node from '../images/node.png';
import python from '../images/python.png';
import figma from '../images/figma.png';
import ml from '../images/ml.png';
import dl from '../images/dl.png';
import da from '../images/da.png';





export const WebAppData = [


    {
        id : 1,
        icon: html,
        name:'HTML',
        level: 'Advanced',
    },
    {
        id : 2,
        icon: css,
        name:'CSS',
        level: 'Intermediate',
    },
    {
        id : 3,
        icon: js,
        name:'JavaScript',
        level: 'intermediate',
    },
    {
        id : 4,
        icon: react,
        name:'React',
        level: 'intermediate',
    },
    {
        id : 5,
        icon: node,
        name:'Node Js',
        level: 'Basic',
    },
    {
        id : 6,
        icon: sql,
        name:'SQL',
        level: 'intermediate',
    },

]

export const OthersData = [


    {
        id : 1,
        icon: python,
        name:'Python',
        level: 'intermediate',
    },
    {
        id : 2,
        icon: da,
        name:'Data Analysis',
        level: 'Basic',
    },
    {
        id : 3,
        icon: ml,
        name:'ML',
        level: 'Basic',
    },
    {
        id : 4,
        icon: figma,
        name:'Figma',
        level: 'Basic',
    },
    {
        id : 5,
        icon: dl,
        name:'Deep Learning',
        level: 'Beginner',
    },


]